export default __webpack_public_path__ + "static/media/setting-icon.0bf7a620.svg";